import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import CurrencyDollar from '@/assets/icons/currency-dollar.svg';
import TrendingUp from '@/assets/icons/trending-up.svg';
import User from '@/assets/icons/user.svg';
import { ReachSummary } from '@/components/pages/edit-campaign/use-reach-summary';

export function useMetricContent({
  metricKey,
}: {
  metricKey: keyof ReachSummary;
}) {
  const intl = useIntl();

  return useMemo(() => {
    switch (metricKey) {
      case 'budget':
        return {
          label: intl.formatMessage({
            defaultMessage: 'Total budget',
            description:
              'Reach campaign editor: overall campaign budget shown in summary',
          }),
          icon: CurrencyDollar,
          format: (value: number) => `$${value}`,
        };
      case 'expectedCpa':
        return {
          label: intl.formatMessage({
            defaultMessage: 'Target CPA',
            description: 'Reach summary: goal cost per applicant',
          }),
          icon: CurrencyDollar,
          format: (value: number) => `$${value}`,
        };
      case 'targetApplicants':
        return {
          label: intl.formatMessage({
            defaultMessage: 'Target applicants',
            description: 'Reach summary: planned applicant volume',
          }),
          icon: User,
          format: (value: number) => `${value}`,
        };
      case 'expectedConversion':
        return {
          label: intl.formatMessage({
            defaultMessage: 'Target conversion',
            description: 'Reach summary: applicant-to-hire conversion percent',
          }),
          icon: TrendingUp,
          format: (value: number) => `${value}%`,
        };
      case 'targetHires':
        return {
          label: intl.formatMessage({
            defaultMessage: 'Target hires',
            description: 'Reach summary: planned number of hires',
          }),
          icon: User,
          format: (value: number) => `${value}`,
        };
      default:
        return {
          label: '',
          icon: '',
          format: (value: number) => `${value}`,
        };
    }
  }, [intl, metricKey]);
}
